import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
} from 'react-router-dom';

import { ROUTER } from '@/constants/constants';

import {
  LandingPage,
  LoginPage,
  SignUpPage,
  EmailPage,
  ChangePwdPage,
  CardRegisterPage,
  BillPaymentPage,
  DashboardPage,
  WorkerPage,
  PaymentManagementPage,
  MyCompanyPage,
  AdminUserManagePage,
  AdminUserDetailPage,
  AdminMonthlyBillPage,
  AdminMonthlyBillDetailPage,
  AdminNoticeManagePage,
  ReportPage,
  WorkAddPage,
  WorkReportDetailPage,
  WorkReportEditPage,
  InspectionHistoryPage,
} from './pages';

import GNB from '@/components/common/GNB';
import Footer from '@/components/common/Footer';
import UserRoute from '@/components/common/UserRoute';

import { PageCenter } from '@/styles/common';

const Router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        element={
          <>
            <PageCenter>
              <Outlet />
            </PageCenter>
            <Footer padding='2.5rem' />
          </>
        }
      >
        <Route path={ROUTER.LANDING} element={<LandingPage />} />
        <Route path={ROUTER.LOGIN} element={<LoginPage />} />
        <Route path={ROUTER.SIGNUP} element={<SignUpPage />} />
        <Route path={ROUTER.FIND_PWD.EMAIL} element={<EmailPage />} />
        <Route path={ROUTER.FIND_PWD.CHANGE_PWD} element={<ChangePwdPage />} />
      </Route>

      <Route element={<UserRoute />}>
        <Route path={ROUTER.CARD_REGISTER} element={<CardRegisterPage />} />
        <Route path={ROUTER.PAYMENT_BILL + '/:billId'} element={<BillPaymentPage />} />
        <Route element={<GNB />}>
          <Route path={ROUTER.DASHBOARD} element={<DashboardPage />} />
          <Route
            path={ROUTER.WORK.INSPECTION_HISTORY + '/:id'}
            element={<InspectionHistoryPage />}
          />
          <Route path={ROUTER.WORKER} element={<WorkerPage />} />
          <Route path={ROUTER.PAYMENT} element={<PaymentManagementPage />} />
          <Route path={ROUTER.MYCOMPANY} element={<MyCompanyPage />} />
          <Route path={ROUTER.WORK.DETAIL + '/:id'} element={<ReportPage />} />
          <Route path={ROUTER.WORK.ADD} element={<WorkAddPage />} />
          <Route
            path={ROUTER.WORK.REPORT_DETAIL + '/:id'}
            element={<WorkReportDetailPage />}
          />
          <Route
            path={ROUTER.WORK.REPORT_EDIT + '/:id'}
            element={<WorkReportEditPage />}
          />

          <Route
            path={ROUTER.ADMIN.USER_MANAGE}
            element={<AdminUserManagePage />}
          />
          <Route
            path={ROUTER.ADMIN.USER_MANAGE + '/:id'}
            element={<AdminUserDetailPage />}
          />
          <Route
            path={ROUTER.ADMIN.MONTHLY_BILLS}
            element={<AdminMonthlyBillPage />}
          />
          <Route
            path={ROUTER.ADMIN.MONTHLY_BILL_DETAIL + '/:id'}
            element={<AdminMonthlyBillDetailPage />}
          />
          <Route
            path={ROUTER.ADMIN.NOTICE_MANAGE}
            element={<AdminNoticeManagePage />}
          />
        </Route>
      </Route>
      <Route path='/*' element={<div>올바르지 않은 접근입니다.</div>} />
    </>
  )
);

export default Router;
